import { useState } from 'react'
import { BsFillXSquareFill } from 'react-icons/bs'

import { useSelector } from 'react-redux'

import { useProcessContactAddress } from '../../../../../hooks/fetch/contactAddress/useProcessContactAddress'
import useContactAddInfo from '../../../../../hooks/useContactAddInfo'
import useContactAddressShared from '../../../../../hooks/useContactAddressShared'
import useContactBasicInfo from '../../../../../hooks/useContactBasicInfo'
import useContactSiteInfo from '../../../../../hooks/useContactSiteInfo'
import useCreateContact from '../../../../../hooks/useCreateContact'
import { selectRole } from '../../../../../slices/authSlice'

import userRole from '../../../../../config/userRole'
import CreateBasicInfo from './CreateBasic/CreateContactBasic'
import CreateAddInfo from './CreateContactAddInfo/CreateContactAddInfo'
import CreateSiteInfo from './CreateContactSiteInfo/CreateContactSiteInfo'

import { validateContactForm } from '../../../../../util/validateContactForm'

const CreateContact = () => {
  const [isShowAddInfo, setIsShowAddInfo] = useState(false)
  const [isShowSiteInfo, setIsShowSiteInfo] = useState(false)

  const { navigatePrevPage } = useCreateContact()

  const contactBasicInfo = useContactBasicInfo()
  const contactAddInfo = useContactAddInfo()
  const contactSiteInfo = useContactSiteInfo()
  const { category } = useContactAddressShared()

  const { lastName } = contactBasicInfo.state

  const allState = {
    ...contactBasicInfo.state,
    ...contactAddInfo.address.state,
    ...contactAddInfo.other.state,
    ...contactSiteInfo.state,
    category,
  }

  const role = useSelector(selectRole)

  const registerdContactAddress = {
  ...allState,
  externalNumbers: contactBasicInfo.state.externalNumbers
    .filter((row) => row.externalPhoneNumber.trim() !== '')
    .map((row, idx) => {
      const isEmptyLabel =
        row.labelCode == null || // null/undefined
        (row.labelCode === 99 && (row.customLabel ?? '').trim() === '')

      return {
        ...row,
        labelCode: isEmptyLabel ? 9 : row.labelCode,
        customLabel: isEmptyLabel ? '' : row.customLabel,
        displayOrder: row.displayOrder ?? idx + 1,
      }
    }),
  isFavorite: false,
  contactName: allState.lastName + allState.firstName,
  category: role === userRole['カンパニー管理者'] ? 'shared' : 'personal',
}


  const { registContactAddress } = useProcessContactAddress()

  return (
    <div className="box inner-box stack">
      <span className="cursor-pointer upper-right" onClick={navigatePrevPage}>
        <BsFillXSquareFill size={'1rem'} />
      </span>

      <CreateBasicInfo {...contactBasicInfo} />

      <div className="mt-5">
        <h6>
          <span
            className="cursor-pointer"
            onClick={() => setIsShowAddInfo((prev) => !prev)}
          >
            {isShowAddInfo ? '▾' : '▸'}その他の項目
          </span>
        </h6>
        <hr />
      </div>

      {isShowAddInfo ? (
        <CreateAddInfo {...contactAddInfo} />
      ) : (
        <p>その他の連絡先項目を追加できます。</p>
      )}

      <div className="mt-5">
        <h6>
          <span
            className="cursor-pointer"
            onClick={() => setIsShowSiteInfo((prev) => !prev)}
          >
            {isShowSiteInfo ? '▾' : '▸'}Webサイト/SNS情報
          </span>
        </h6>
      </div>
      <hr />
      {isShowSiteInfo ? (
        <CreateSiteInfo {...contactSiteInfo} />
      ) : (
        <p>WebアドレスやSNSアカウントを追加できます。</p>
      )}

      <hr />
      <div className="switcher">
        <button
          type="button"
          className="submitButton"
          onClick={(e) => {
            const errorMsg = validateContactForm(registerdContactAddress)

            if (errorMsg) {
              alert(errorMsg)
              return
            }

            registContactAddress(e, registerdContactAddress)
          }}
          disabled={lastName.length === 0}
        >
          連絡先を保存
        </button>

        <button
          type="button"
          className="submitButton btn-danger ms-3"
          onClick={navigatePrevPage}
        >
          キャンセル
        </button>
      </div>
    </div>
  )
}

export default CreateContact
